export enum ReportScore {
  UNKNOWN = 'Unknown',
  LOW = 'Unreliable',
  MEDIUM = 'Partially reliable',
  HIGH = 'Reliable',
}

export type SourceProps = {
  link: string;
  title?: string;
  name?: string;
  image?: string | null;
  publicationDate?: string;
  score: ReportScore;
  showEnrichedLayout?: boolean;
};
